/* AM-CART — Línea de confianza bajo el botón de pago (envío gratis + garantía).

   Calca el social proof de maison-moda.com ("Free Shipping + 30-Day Money-Back
   Guarantee") justo debajo del botón. Se inserta en el pie (.ft) del drawer, que
   am-cart.js RE-DIBUJA (innerHTML) en cada cambio del carrito, por eso usamos un
   MutationObserver para volver a colocarla tras cada re-render.

   Textos desde el bloque "confianza" de la config JSON #am-cart-config. */

(function () {
  'use strict';

  function leerConfig() {
    var def = { activo: true, items: ['30 Días de Garantía', 'Envío Gratis'] };
    var el = document.getElementById('am-cart-config');
    if (!el) return def;
    try {
      var c = JSON.parse(el.textContent).confianza;
      if (!c) return def;
      return {
        activo: c.activo !== false,
        items: (c.items && c.items.length) ? c.items : def.items
      };
    } catch (e) { return def; }
  }

  var CFG = leerConfig();
  if (!CFG.activo) return;

  var CSS =
    '.am-trust{text-align:center;margin:10px 0 2px;font-size:11px;' +
    'font-weight:700;line-height:1.3;color:#111111;}' +
    '.am-trust__item{display:inline-flex;align-items:center;gap:5px;' +
    'white-space:nowrap;vertical-align:middle;}' +
    '.am-trust svg{width:13px;height:13px;flex:0 0 13px;fill:currentColor;}' +
    '.am-trust__sep{margin:0 9px;color:#111111;font-weight:700;vertical-align:middle;}';

  /* Escudo con check = garantía; camión = envío. fill:currentColor → siguen al texto. */
  var SHIELD = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg>';
  var TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9 1.96 2.5H17V9.5h2.5zM18 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>';

  function iconoDe(t) {
    if (/garant/i.test(t)) return SHIELD;
    if (/env[ií]o|gr[aá]tis|shipping/i.test(t)) return TRUCK;
    return '';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function html() {
    var sep = '<span class="am-trust__sep">|</span>';
    return '<div class="am-trust">' +
      CFG.items.map(function (t) {
        return '<span class="am-trust__item">' + iconoDe(t) + esc(t) + '</span>';
      }).join(sep) +
      '</div>';
  }

  function ensureStyle(root) {
    if (!root.querySelector('style[data-am-trust]')) {
      var st = document.createElement('style');
      st.setAttribute('data-am-trust', '');
      st.textContent = CSS;
      root.appendChild(st);
    }
  }

  function insert(root) {
    var ft = root.querySelector('.ft');
    if (!ft) return;
    var form = ft.querySelector('.ft__form');   // solo con botón de pago (carrito con items)
    if (!form) return;
    if (ft.querySelector('.am-trust')) return;   // ya está: evita bucle del observer
    ensureStyle(root);
    var tmp = document.createElement('div');
    tmp.innerHTML = html();
    form.parentNode.insertBefore(tmp.firstChild, form.nextSibling);  // justo debajo del botón
  }

  function start() {
    var host = document.getElementById('amCart');
    var root = host && host.shadowRoot;
    if (!root) return false;
    var ft = root.querySelector('.ft');
    if (!ft) return false;
    insert(root);
    // .ft es un elemento estable; am-cart.js solo reemplaza su innerHTML → childList basta.
    new MutationObserver(function () { insert(root); }).observe(ft, { childList: true });
    return true;
  }

  var iv = setInterval(function () { if (start()) clearInterval(iv); }, 300);
})();
